import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import MuiTableRow from '@mui/material/TableRow';
import { useCallback } from 'react';
import { useIsCtrlPressed } from '../../useSmartTable/useKeyPresses';
import { useSTRow, useSTRows } from '../SmartTableContext';
import { getRowStyle } from '../helpers';
import { TableBodyCellWithData } from './TableBodyCellWithData';
import { TableCheckbox } from './TableCheckbox';
export function TableBodyRowWithData({ row, columns, index, }) {
    const { rowsSelectEnabled } = useSTRows();
    const { isSelected, toggleSelected } = useSTRow(row);
    const isCtrlPressed = useIsCtrlPressed();
    const ctrlAndRowClickCallback = useCallback((e) => {
        if (!isCtrlPressed) {
            return;
        }
        toggleSelected();
        e.preventDefault();
    }, [isCtrlPressed, toggleSelected]);
    return (_jsxs(MuiTableRow, { sx: getRowStyle(row, isSelected), onClick: ctrlAndRowClickCallback, children: [rowsSelectEnabled && _jsx(TableCheckbox, { checked: isSelected, onClick: toggleSelected }), columns.map((column, columnIndex) => (_jsx(TableBodyCellWithData, { row: row, column: column, columnIndex: columnIndex }, `table-body-cell-${row.id}-${column.fieldName}`)))] }, `table-row-${index}`));
}
//# sourceMappingURL=TableBodyRowWithData.js.map